import type { RouteRecordRaw } from 'vue-router';
import { Guest, MFAInProgress } from '~/middlewares';

export const authRoutes: RouteRecordRaw[] = [
    {
        path: '/login',
        component: () => import('~/views/login/Layout.vue'),
        meta: {
            middlewares: [Guest],
        },
        children: [
            {
                name: 'login.index',
                path: '',
                component: () => import('~/views/login/Login.vue'),
            },
            {
                name: 'login.totp',
                path: 'totp',
                meta: {
                    middlewares: [MFAInProgress],
                },
                component: () => import('~/views/login/TOTP.vue'),
            },
            {
                name: 'login.key',
                path: 'key',
                meta: {
                    middlewares: [MFAInProgress],
                },
                component: () => import('~/views/login/Key.vue'),
            },
            {
                name: 'login.reset_password',
                path: 'reset',
                component: () => import('~/views/login/ResetPassword.vue'),
            },
            {
                name: 'login.reset_password.token',
                path: 'reset/:token',
                component: () => import('~/views/login/ResetPasswordToken.vue'),
            },
        ],
    },
    // Backwards compatability with v1
    {
        name: 'login.sso',
        path: '/auth/login/sso',
        meta: {
            middlewares: [Guest],
            hidden: true,
        },
        redirect: (to) => {
            return {
                name: 'login.index',
                query: to.query,
            };
        },
    },
];
